import { render, staticRenderFns } from "./display-content.vue?vue&type=template&id=bafb7288&"
import script from "./display-content.vue?vue&type=script&lang=js&"
export * from "./display-content.vue?vue&type=script&lang=js&"
import style0 from "./display-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bafb7288')) {
      api.createRecord('bafb7288', component.options)
    } else {
      api.reload('bafb7288', component.options)
    }
    module.hot.accept("./display-content.vue?vue&type=template&id=bafb7288&", function () {
      api.rerender('bafb7288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/display-content.vue"
export default component.exports